export default "__VITE_ASSET__CSiwRVLH__"